__turbopack_context__.v({
  "sort": "catalog-sort-module-scss-module__701WPW__sort",
});
